import { useTranslation } from 'react-i18next';

import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import useReadonlyTitle from './vm';

export interface ReadonlyTitleProps {
  className?: string;
}

const ReadonlyTitle = ({ className }: ReadonlyTitleProps) => {
  const { t } = useTranslation([i18nNS.TIMER]);

  const { title } = useReadonlyTitle();

  return (
    <Typography variant="h4Medium" color="common.black" className={className}>
      {title || t('untitled_timer', { ns: i18nNS.TIMER })}
    </Typography>
  );
};

export default ReadonlyTitle;
